import { ref } from 'vue';

export type AppRoute =
  | 'setup'
  | 'login'
  | 'register'
  | 'admin'
  | 'family'
  | 'child-home'
  | 'friend'
  | 'drawing'
  | 'voice'
  | 'video'
  | 'play-request'
  | 'mailbox'
  | 'approvals'
  | 'parent-settings';

const routes: AppRoute[] = [
  'setup',
  'login',
  'register',
  'admin',
  'family',
  'child-home',
  'friend',
  'drawing',
  'voice',
  'video',
  'play-request',
  'mailbox',
  'approvals',
  'parent-settings'
];

const route = ref<AppRoute>(readRouteFromHash());

if (typeof window !== 'undefined') {
  window.addEventListener('hashchange', () => {
    route.value = readRouteFromHash();
  });
}

export function useNavigation() {
  function navigate(next: AppRoute) {
    route.value = next;
    if (typeof window !== 'undefined') {
      window.location.hash = next;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return { route, navigate };
}

function readRouteFromHash(): AppRoute {
  if (typeof window === 'undefined') return 'family';
  const hash = window.location.hash.replace('#', '') as AppRoute;
  return routes.includes(hash) ? hash : 'family';
}
